import axios from "axios";
import React, { useState, useEffect } from "react";
import CreaDocencia from "./Equipos/CreaModals/CreaDocenciaServicio";
import Cookies from "universal-cookie";

function Titulo9SeccionA(props) {
  const cookies = new Cookies();
  const [list, setList] = useState([]);

  useEffect(() => {
    obtenerLista();
  }, [props.idSolicitud]);

  const obtenerLista = async () => {
    try {
      const response = await axios.get(
        `https://suadesarrollo.azurewebsites.net/api/ObtenerConvenioDocenciaPorSolicitudId?SolicitudId=${props.idSolicitud}`,
      );
      setList(response.data || []);
    } catch (error) {
      console.log(error);
    }
  };

  const onRegistroCreado = (data) => {
    if (Array.isArray(data)) {
      setList((prev) => [...data, ...prev]);
    } else {
      // fallback si backend no devuelve registros creados
      obtenerLista();
    }
  };

  return (
    <div className="container-fluid">
      <div className="card shadow mb-4">
        <div className="card-header py-3">
          <h6 className="font-weight-bold text-primary">
            CONVENIOS DOCENCIA SERVICIO
          </h6>
        </div>

        <div className="card-body">
          {cookies.get("tipo_Usuario") == 2 &&
            window.location.href.includes("ProcesoAutoevaluacion") && (
              <>
                <CreaDocencia
                  idSolicitud={props.idSolicitud}
                  onRegistroCreado={onRegistroCreado}
                />
                <br />
                <a href="/formatos/FormatoConvenios.xslx" download>
                  Descargar Formato
                </a>
              </>
            )}

          <hr />

          <div className="table-responsive">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Id</th>
                  <th>Nombre Institución</th>
                  <th>Programa Académico</th>
                  <th>Fecha inicio</th>
                  <th>SolicitudId</th>
                </tr>
              </thead>
              <tbody>
                {list.length > 0 ? (
                  list.map((item) => (
                    <tr key={item.id}>
                      <td>{item.id}</td>
                      <td>{item.nombre_Institucion}</td>
                      <td>{item.programa_Academico}</td>
                      <td>{item.fecha_inicio}</td>
                      <td>{item.solicitudId}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="text-center">
                      No hay registros
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Titulo9SeccionA;
